var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from 'aurelia-templating';
import { autoinject, transient } from 'aurelia-dependency-injection';
import { BindingSignaler } from "aurelia-templating-resources";
import { computedFrom } from 'aurelia-binding';
import { Reflection } from '../../../utilities/reflection';
import { Router } from 'aurelia-router';
var EntityItem = /** @class */ (function () {
    function EntityItem(bindingSignaler, router) {
        this.bindingSignaler = bindingSignaler;
        this.router = router;
        this.cacheTabKey = null;
        this.removeLastVisitedTabCache = true;
        this.steps = [];
        this.defaultStepResolver = null;
        this.item = {};
    }
    Object.defineProperty(EntityItem.prototype, "currentStep", {
        get: function () {
            return this._currentStep;
        },
        set: function (value) {
            this._currentStep = value;
            if (this.steps && this.steps.length > 0) {
                this.itemChanged();
            }
            if (this.onStepClicked)
                this.onStepClicked(value);
        },
        enumerable: false,
        configurable: true
    });
    EntityItem.prototype.itemChanged = function () {
        this.bindingSignaler.signal('refresh-item');
    };
    EntityItem.prototype.getItemModel = function (step) {
        if (typeof (this.item) == "function") {
            return this.item(step);
        }
        if (step.getModel) {
            return step.getModel(this.item);
        }
        return this.item;
    };
    EntityItem.prototype.getShow = function (step) {
        return typeof (step.show) == "function" ? step.show() : step.show;
    };
    EntityItem.prototype.isVisible = function (func) {
        return func();
    };
    EntityItem.prototype.bind = function () {
        this.currentStep = this.defaultStepResolver ? this.defaultStepResolver(this.steps) : undefined;
        if (!this.cacheTabKey) {
            this.cacheTabKey = "tab-" + this.router.currentInstruction.config.name;
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityItem.prototype, "cacheTabKey", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], EntityItem.prototype, "removeLastVisitedTabCache", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], EntityItem.prototype, "steps", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Function)
    ], EntityItem.prototype, "defaultStepResolver", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], EntityItem.prototype, "item", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], EntityItem.prototype, "onStepClicked", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._currentStep; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], EntityItem.prototype, "currentStep", null);
    EntityItem = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [BindingSignaler, Router])
    ], EntityItem);
    return EntityItem;
}());
export { EntityItem };
